<template>
  <div id="income-chart">
    <div class="income-chart-title">数据指标</div>
    <div class="dv-charts-container">
      <p class="item">平均租金水平: <span class="value">¥ {{rent}}</span></p>
      <p class="item">空置房屋数: <span class="value" style="color: #3ff9ed">{{num}}</span></p>
      <p class="item">空置率: <span class="value">{{rate}}%</span></p>
    </div>
  </div>
</template>
<script>
import { getRandomNumber } from '@/utils/common'
export default {
  name: 'Income',
  data () {
    return {
      rent: getRandomNumber(520.00, 600.00),
      num: getRandomNumber(100, 180),
      rate: getRandomNumber(8, 16)
    }
  }
}
</script>
<style scoped lang="less">
#income-chart {
  width: 30%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;

  .income-chart-title {
    height: 50px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .dv-charts-container {
    height: calc(~"100% - 50px");
    padding: 20px;

    .item {
      font-size: 14px;
    }

    .value {
      font-size: 35px;
      font-weight: bold;
      color: #58a1ff;
      margin: 0 5px;
      margin-bottom: -5px;
    }

  }
}

</style>
